import { z } from 'zod';
import { cancelAnnotationPayloadSchema } from './cancel.schema';

export type CancelAnnotationPayload = {
  proccessingDuration?: unknown;
};

export const cancel = (
  annotationId: number,
  payload: CancelAnnotationPayload = {}
) => {
  return {
    endpoint: `/annotations/${annotationId}/cancel`,
    method: 'POST',
    payloadSchema: cancelAnnotationPayloadSchema,
    payload,
    responseSchema: z.unknown(),
  } as const;
};
